var map = {
	"./DealDetail": 20814,
	"./DealDetail.json": 20814,
	"./StoreListData": 92197,
	"./StoreListData.js": 92197,
	"./TnC-detail": 30431,
	"./TnC-detail.json": 30431,
	"./cart-case-1": 91209,
	"./cart-case-1.json": 91209,
	"./cart-case-3": 81839,
	"./cart-case-3.json": 81839,
	"./cart-case-3a": 21225,
	"./cart-case-3a.json": 21225,
	"./cart-case-5": 78394,
	"./cart-case-5.json": 78394,
	"./cart-case-6": 96057,
	"./cart-case-6.json": 96057,
	"./cart-case-7": 24804,
	"./cart-case-7.json": 24804,
	"./cart-case-8": 78149,
	"./cart-case-8.json": 78149,
	"./cart-deal": 59637,
	"./cart-deal-onceOff": 58844,
	"./cart-deal-onceOff.json": 58844,
	"./cart-deal.json": 59637,
	"./cart-dual": 5402,
	"./cart-dual.json": 5402,
	"./cart-null": 42816,
	"./cart-null.json": 42816,
	"./cart-out-of-stock": 8143,
	"./cart-out-of-stock.json": 8143,
	"./cart-preorder": 58968,
	"./cart-preorder.json": 58968,
	"./cart-sample": 68181,
	"./cart-sample.json": 68181,
	"./cart-upgrade": 36189,
	"./cart-upgrade.json": 36189,
	"./cart-vas": 44376,
	"./cart-vas.json": 44376,
	"./dealsSelectionMockData": 83870,
	"./dealsSelectionMockData.js": 83870,
	"./getAllDeals": 11008,
	"./getAllDeals.json": 11008,
	"./getAllProducts": 66473,
	"./getAllProducts.json": 66473,
	"./mockRenderComponent": 29151,
	"./mockRenderComponent.js": 29151,
	"./order-confirmation": 50393,
	"./order-confirmation-2": 21781,
	"./order-confirmation-2.json": 21781,
	"./order-confirmation.json": 50393,
	"./order-detail-cancelled": 92701,
	"./order-detail-cancelled.json": 92701,
	"./order-detail-error": 62825,
	"./order-detail-error.json": 62825,
	"./order-detail-error_1": 65907,
	"./order-detail-error_1.json": 65907,
	"./order-detail-failed": 11237,
	"./order-detail-failed.json": 11237,
	"./order-detail-mess": 47811,
	"./order-detail-mess.json": 47811,
	"./order-detail-paid": 74667,
	"./order-detail-paid.json": 74667,
	"./order-detail-processing": 28029,
	"./order-detail-processing.json": 28029,
	"./order-history-1": 18498,
	"./order-history-1.json": 18498,
	"./order-history-2": 95675,
	"./order-history-2.json": 95675,
	"./order-history-3": 13637,
	"./order-history-3.json": 13637,
	"./order-history-4": 95093,
	"./order-history-4.json": 95093,
	"./order-history-products": 3628,
	"./order-history-products.json": 3628,
	"./order-status-map": 43444,
	"./order-status-map.js": 43444,
	"./order-tracking-statuses": 64140,
	"./order-tracking-statuses-approved": 92365,
	"./order-tracking-statuses-approved.json": 92365,
	"./order-tracking-statuses-cond-approved": 41763,
	"./order-tracking-statuses-cond-approved.json": 41763,
	"./order-tracking-statuses-condition": 64214,
	"./order-tracking-statuses-condition.json": 64214,
	"./order-tracking-statuses-declined": 1584,
	"./order-tracking-statuses-declined.json": 1584,
	"./order-tracking-statuses-delivered": 28131,
	"./order-tracking-statuses-delivered.json": 28131,
	"./order-tracking-statuses-error": 77567,
	"./order-tracking-statuses-error.json": 77567,
	"./order-tracking-statuses-failed": 41572,
	"./order-tracking-statuses-failed.json": 41572,
	"./order-tracking-statuses-pending": 75768,
	"./order-tracking-statuses-pending.json": 75768,
	"./order-tracking-statuses-processing": 54647,
	"./order-tracking-statuses-processing.json": 54647,
	"./order-tracking-statuses.json": 64140,
	"./order-tracking-vetting-status": 72930,
	"./order-tracking-vetting-status.json": 72930,
	"./orders-customer-response": 56743,
	"./orders-customer-response.json": 56743,
	"./payment-intent": 79687,
	"./payment-intent.json": 79687,
	"./preOrderFormDetails": 97710,
	"./preOrderFormDetails.json": 97710,
	"./products-cart": 88306,
	"./products-cart.json": 88306,
	"./searchProductTabsMock": 12729,
	"./searchProductTabsMock.js": 12729,
	"./storeList": 91764,
	"./storeList.json": 91764,
	"./vasDetails": 14604,
	"./vasDetails.json": 14604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88000;